import React, { useEffect } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Segment } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import SimpleFileUpload from '~/components/SimpleFileUpload'
import WYSIWYGEditor from '~/components/WYSWYGEditor'
import { StyledTabPane } from './style'

interface LanguageTabProps {
  getValues: any
  index: number
  watchStatus: boolean
  control: any
  languageId: string
  activeIndex: number
  setValue: any
  clearErrors: any
}

const LanguageTab: React.FC<LanguageTabProps> = (props) => {
  const { t } = useTranslation()
  const {
    getValues,
    index,
    control,
    languageId,
    activeIndex,
    setValue,
    clearErrors
  } = props

  const stripHtml = (html: string) => {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }

  const langAdded = getValues(`languages[${index}].content`) && getValues('id')
  const fileFieldName = langAdded ? `languages[${index}].fileEdit` : `languages[${index}].file`
  
  const watchHeaderTextField = useWatch({ control, name: `languages[${index}].headerText` })
  const watchFileField = useWatch({ control, name: fileFieldName })
  
  const isHeaderTextEmpty = !stripHtml(watchHeaderTextField).trim()
  const isFileEmpty = !watchFileField

  return <StyledTabPane key={languageId}>
    <Segment>
      <FormFields.Input
        control={control}
        name={`languages[${index}].title`}
        label={t('Title')}
        placeholder={t('Title')}
        rules={{
          required: t('Please enter title'),
          maxLength: {
            value: 100,
            message: t('Max. 100 characters allowed')
          }
        }}
      />
      <FormFields.External
        name={`languages[${index}].headerText`}
        label={t('Description')}
        control={control}
        onChange={(value) => {
          setValue(`languages[${index}].headerText`, value)
          if (stripHtml(value).trim()) {
            clearErrors(fileFieldName)
            clearErrors(`languages[${index}].headerText`)
          }
        }}
        rules={{
          required: isFileEmpty ? t('Please enter description') : false
        }}
        tag='textarea'
      >
        <WYSIWYGEditor key={'1'} maxLength={1000} />
      </FormFields.External>
      <FormFields.External
        name={`languages[${index}].footerText`}
        label={t('Footer description')}
        control={control}
        tag='textarea'
      >
        <WYSIWYGEditor key={'2'} maxLength={1000} />
      </FormFields.External>
      <FormFields.External
        control={control}
        label={t('File')}
        keyName={getValues(`languages[${index}]`)}
        onChange={(file: File) => {
          setValue(`languages[${index}].file`, file)
          if (file) {
            clearErrors(`languages[${index}].headerText`)
            clearErrors(fileFieldName)
          }
        }}
        id={getValues('id') || `languages[${index}].file`}
        name={fileFieldName}
        rules={{
          required: isHeaderTextEmpty ? t('Please upload file') : false
        }}
      >
        <SimpleFileUpload
          activeTabIndex={activeIndex}
          sizeLimitInMB={300}
          accept={['.pdf', '.doc', '.docx', '.txt', '.csv', '.xls', '.xlsx', '.png', '.jpeg', '.jpg', '.bmp', '.mp4']} />
      </FormFields.External>
    </Segment>
  </StyledTabPane>
}
export default LanguageTab